import React from 'react'
import Classnames from 'classnames'
import PropTypes from 'prop-types'
import {
  TextStyle, //
} from './styled'
import ReactTooltip from 'react-tooltip'
// import { ICONS } from '../../themes'

export class Text extends React.PureComponent {
  render() {
    const {
      className, //
      onMouseEnter,
      onMouseLeave,
      useTootipFor,
      useTootip,
      useEllipsis,
      tootipValue,
      tootipHtmlValue,
      tooltipPlace,
      children,
      style,
    } = this.props

    return (
      <TextStyle
        className={Classnames(className)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-tip={tootipValue}
        data-for={useTootipFor}
        style={style}
      >
        {/* <img src={src} alt={alt} className="image" /> */}
        {useEllipsis ? (
          <>
            <div className="ellipsis-items">
              <div className="ellipsis-item" data-tip={children}>
                {children}
              </div>
            </div>
          </>
        ) : (
          <>{children}</>
        )}
        {useTootip && (
          <ReactTooltip
            id={useTootipFor}
            place={tooltipPlace}
            effect="solid"
            className="background-white"
            html={true}
          >
            {/* {tootipHtmlValue} */}
          </ReactTooltip>
        )}
      </TextStyle>
    )
  }

  static defaultProps = {
    // alt: 'Image',
    tooltipPlace: 'bottom',
  }

  static propTypes = {
    /**
     * [Image] and [Image.Children] - additional classes
     */
    className: PropTypes.string,
  }
}
